//TODO: https://localforage.github.io/localForage/
//TODO: VUE localstorage extended - https://github.com/ricardogobbosouza/v-localforage
import { defineModule } from "direct-vuex"
import store, { moduleActionContext, moduleGetterContext } from "."
import ApiServices from "Api/ApiFactory"
import { GetAllOrderingListUserPermissionRequest, OrderingListUserPermissionViewModel, OrderingListUserDetailViewModel, CreateUserPermissionCommand, RemoveUserPermissionCommand, UpdateUserPermissionCommand} from "Api/CoreApi";
import ApiFactory from "Api/ApiFactory";
import { UserPermission } from "Api/DynamicwebApi";


export interface IOrderingUserState {
    Users: OrderingListUserDetailViewModel[]
}


const initial : IOrderingUserState = {
    Users : null,
    
}

const orderingListUser = defineModule({
    namespaced: true,
    state: (): IOrderingUserState => initial
    ,
    getters: {
        test(...args): boolean {
            const { state, getters, rootState, rootGetters } = mod1GetterContext((args) as any);
            return false; //TODO:
        },
    },
    mutations: {
        SET_USER_PERMISSOINS(state, userpermissions: OrderingListUserPermissionViewModel[]) {
            state.Users = userpermissions;
        },
        ADD_USER_PERMISSION(state, userpermission: CreateUserPermissionCommand ) {
            // const newUserpermission = new OrderingListUserDetailViewModel({
            //     userIdentity: userpermission.userIdentity,
            //     orderingLists: new Array<OrderingListDetailsWithPermissionViewModel>(),
            // });
            // newUserpermission.orderingLists.push(new OrderingListDetailsWithPermissionViewModel({
            //     id: userpermission.orderingListId
            // }));

            // state.Users.push(newUserpermission);
        },
        CHANGE_USER_PERMISSIONS(state, updated:OrderingListUserPermissionViewModel )
        {
            const userPermissionObj  = state.Users.find(x => x.userIdentity == updated.userIdentity);
            const list = userPermissionObj.orderingLists.find(x => x.id == updated.orderingListId);
            
            const newValues = <OrderingListUserPermissionViewModel>{
                canAdditemFromParent: updated.canAdditemFromParent,
                canRequestAddOfItem : updated.canRequestAddOfItem,
                canExceedBudget : updated.canExceedBudget,
                orderingListId : updated.orderingListId,
                userIdentity : updated.userIdentity
            }

            list.permissions = newValues;

        },
        REMOVE_USER(state, username: string)
        {
            state.Users = state.Users.filter(x => x.userIdentity != username);
        }
    },
    actions: {
        async load(context) {
            const { dispatch, commit, getters, state } = authActionContext(context);
            const client = await ApiFactory.getUserPermissionsClient();
            const result = await client.getAll(new GetAllOrderingListUserPermissionRequest());
            commit.SET_USER_PERMISSOINS(result.permissions);
        },
        async createUserPermission(context, command: CreateUserPermissionCommand) {
            const { dispatch, commit, getters, state } = authActionContext(context);
            
            const client = await ApiFactory.getUserPermissionsClient()
            const result = await client.createUserPermission(command);
            // commit.ADD_USER_PERMISSION(command);

            //dispatch.. 
            await store.dispatch.orderingListUser.load();
            
        },
        async removeUserPermission(context, command: RemoveUserPermissionCommand) {
            const { dispatch, commit, getters, state } = authActionContext(context);
            
            const client = await ApiFactory.getUserPermissionsClient();
            const result = await client.removeUserPermission(command);
            // commit.ADD_USER_PERMISSION(command);

            //dispatch.. 
            await store.dispatch.orderingListUser.load();
            
        },
        async updateUserPermission(context, command: UpdateUserPermissionCommand) {
            const { dispatch, commit, getters, state } = authActionContext(context);
            
            try{
                const client = await ApiFactory.getUserPermissionsClient();
                const result = await client.updateUserPermission(command);
                // commit.CHANGE_USER_PERMISSIONS(command);
    
            }catch(err){

            }
        },
        async removeUser(context, username: string) {
            const { dispatch, commit, getters, state } = authActionContext(context);
            
            try{
                const client = await ApiFactory.getDynamicwebClient();
                const result = await client.deleteUser(username);
                commit.REMOVE_USER(username);
    
            }catch(err){

            }
        },
        

    }
    
});

export default orderingListUser
const mod1GetterContext = (args: [any, any, any, any]) => moduleGetterContext(args, orderingListUser);
const authActionContext = (context: any) => moduleActionContext(context, orderingListUser);